module.exports = __webpack_public_path__ + "img/43_45.4febfb4f.png";